<template>
  <div class="projectPicker" :style="{'--pickerWidth': '400px'}">
    <v-autocomplete
      :items="projectList"
      v-model="selectedProject"
      item-value="prefix"
      @change="handleProjectChange"
      @blur="handleBlurInput"
      :filter="filterProjects"
      hide-details
      auto-select-first
    >
      <template #selection="{ item }">
        <span class="selected-name text-truncate">
          {{ $filters.getMatchingTranslation({ value: item.name, locale: projectLanguage }) }}
        </span>
      </template>

      <template #item="{ item }">
        <span class="text-truncate" >
          {{ $filters.getMatchingTranslation({ value: item.name, locale: $i18n.locale }) }}
        </span>
        <v-icon v-if="item.isUserProject" small class="ml-1">mdi-account-edit-outline</v-icon>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  name: 'ProjectPicker',

  data () {
    return {
      selectedProject: null
    }
  },

  computed: {
    projectLanguage () {
      return this.$store.getters['app/projectLanguage']
    },
    projectList () {
      const userProjects = this.$store.getters['authentication/userInfo']?.project || []
      const markedUserProjects = userProjects.map(item => ({ ...item, isUserProject: true }))
      const userProjectPrefixes = userProjects.map(item => item.prefix)
      const combinedList = [
        ...markedUserProjects,
        ...this.sortedProjectList.filter(item => !userProjectPrefixes.includes(item.prefix))
      ]

      return combinedList
    },

    sortedProjectList () {
      const projects = cloneDeep(this.$store.getters['project/getProjects']) || []
      return projects.sort((a, b) => {
        const nameA = this.$filters.getMatchingTranslation({ value: a.name, locale: this.$i18n.locale }).toLowerCase()
        const nameB = this.$filters.getMatchingTranslation({ value: b.name, locale: this.$i18n.locale }).toLowerCase()
        if (nameA < nameB) return -1
        if (nameA > nameB) return 1
        return 0
      })
    },

    targetRoute () {
      const firstMatched = this.$route.matched?.[0]?.name
      if (firstMatched === 'home') {
        return 'project-overview'
      }
      return firstMatched || 'project-overview'
    }
  },

  methods: {
    filterProjects (item, queryText, itemText) {
      const prefix = item.prefix.toLowerCase()
      const name = this.$filters.getMatchingTranslation({ value: item.name, locale: this.$i18n.locale })?.toLowerCase()
      const query = queryText.toLowerCase()
      return name?.includes(query) || prefix?.includes(query)
    },
    handleBlurInput () {
      if (this.selectedProject == null) {
        this.selectedProject = this.projectInFocus?.prefix || null
      }
    },
    handleProjectChange (prefix) {
      if (!prefix) {
        return
      }
      this.$router.push({ name: this.targetRoute, params: { prefix } })
        .catch(() => {})
    }
  },

  watch: {
    'projectInFocus.prefix': {
      immediate: true,
      handler (newPrefix) {
        this.selectedProject = newPrefix
      }
    }
  }
}
</script>

<style scoped lang="scss">

.projectPicker:focus-within {
  flex-basis: 375px;
}

::v-deep .v-input__slot,
::v-deep .v-input__slot:before {
  border: none !important;
}

::v-deep .v-select__selections {
  & input {
    cursor: pointer;
    min-width: 100px !important;
    position: absolute;

    &:focus {
      cursor: text;
    }
  }

  & span.selected-name {
    opacity: 1;
    transition: opacity .4s ease-out;

    @media screen and (max-width: 600px) {
      max-width: 120px;
    }
  }

  &:focus-within span.selected-name {
    opacity: 0;
  }
}

::v-deep .v-input__append-inner {
  cursor: pointer;
}
</style>
